export enum ShipmentCardType {
  Finished = 'Finished Shipments',
  InTransit = 'In Transit Shipments',
  Pending = 'Pending shipments'
}
